import * as types from '../actions/actionTypes';
import initialState from './initialState';
import moment from 'moment';

import { sessionSelector } from '../selectors/sessionSelectors';

const getInitialState = () => {
    const state = JSON.parse(localStorage.getItem('session'));
    
	if (!state) return null;
	const session = sessionSelector({ session: state });
	const serverNow = moment().add('milliseconds', state.server_offset);
	if (moment(session.refresh_expires) < serverNow) return null;
	return state;
};

export default function sessionReducer(state = getInitialState() || initialState.session, action) {
	switch (action.type) {
		case types.LOGIN__USER_REMEMBER_ME_SUCCESS:
		case types.ADMIN__LOGIN_AS_USER_SUCCESS: {
            const newSession = { token: action.response.token, refresh: action.response.refresh, tokenDate: moment() };
			localStorage.setItem('session', JSON.stringify(newSession));
			return { token: action.response.token, refresh: action.response.refresh, requiresLogin: false, tokenDate: moment() };
        }
		case types.AUTH__AUTHENTICATE_USER_SUCCESS: {
            const newSession = { token: action.response.token, refresh: action.response.refresh, tokenDate: moment() };
            if (action.response.rememberMe.length > 0) {
                localStorage.setItem('rememberMe', action.response.rememberMe);
            }
            localStorage.setItem('session', JSON.stringify(newSession));
            return newSession;
        }
		case types.SESSION__REFRESH_TOKEN_SUCCESS: {
            const newSession = { token: action.response.token, refresh: action.response.refresh, tokenDate: moment() };
            localStorage.setItem('session', JSON.stringify(newSession));
            return newSession;
        }
		case types.LOGOUT__USER_SUCCESS: {
            localStorage.removeItem('rememberMe');
            localStorage.removeItem('session');
			return { ...initialState.session };
		}
		default:
			return state;
	}
}